/* eslint-disable quote-props */
import {
  DashboardIcon,
  EditIcon,
  AccountIcon,
  ScheduleIcon,
  DraftIcon,
  FolderIcon,
  TeamIcon,
} from "./components/LucideIcons";
import React from "react";
import { CircleUserRound } from "lucide-react";

import Page404 from "layouts/404";
import Auth from "layouts/auth";
import AppLayout from "layouts/app";

import AuthPage from "pages/auth";
import Forgot from "pages/forgot";
import signupInvite from "./pages/signupInvite";
import ResetPassword from "pages/resetPassword";

import Dashboard from "pages/dashboard";
import Post from "pages/post";
import Profile from "pages/profile";
import Pricing from "pages/pricing";
import Accounts from "pages/accounts";
import Schedule from "pages/schedule";
// import Reports from "pages/reports";
import Drafts from "pages/drafts";
import Content from "pages/content";
import Teams from "pages/teams";
import StripeSuccess from "pages/stripeCallback/success";
import StripeFailed from "pages/stripeCallback/failed";
import Credits from "pages/credits";


// Компонент иконки профиля с CSS переменной цвета
const ProfileIcon = () => {
  return (
    <CircleUserRound size={20} strokeWidth={1.5} color="var(--icon-color)" />
  );
};

const menuPages = {
  menu: [
    { link: "/app/dashboard", Icon: DashboardIcon },
    { link: "/app/post", Icon: EditIcon },
    { link: "/app/accounts", Icon: AccountIcon },
    { link: "/app/schedule", Icon: ScheduleIcon },
    // { link: "/app/reports", Icon: AssessmentOutlined },
    { link: "/app/drafts", Icon: DraftIcon },
    { link: "/app/content", Icon: FolderIcon },
    { link: "/app/teams", Icon: TeamIcon },
    { link: "/app/profile", Icon: ProfileIcon, isBottom: true },
  ],

  pages: {
    auth: {
      view: Auth,
      index: "login",
      items: {
        login: AuthPage,
        signup: AuthPage,
        forgot: Forgot,
        "reset/:token": ResetPassword,
        signupInvite: signupInvite,
      },
    },
    app: {
      view: AppLayout,
      index: "dashboard",
      items: {
        dashboard: Dashboard,
        post: Post,
        accounts: Accounts,
        schedule: Schedule,
        // "reports": Reports,
        drafts: Drafts,
        content: Content,
        teams: Teams,
        pricing: Pricing,
        credits: Credits,
        profile: Profile,
        "stripe/success": StripeSuccess,
        "stripe/failed": StripeFailed,
      },
    },
    404: Page404,
    "*": "404",
    // Always try the app: the XSRF-TOKEN cookie lives only SESSION_LIFETIME (2h), while the
    // "remember me" cookie keeps the session alive for weeks. Gating on it sent returning users
    // to the login screen although the server would still have recognised them. A visitor who
    // really is signed out gets a 401 from loadMetaData and lands on /auth/login from there.
    "/": "app",
  },
};

export default menuPages;
